import React from 'react';
import styles from './PrivateBody.module.scss';
import SidebarPanel from '../SidebarPanel/SidebarPanel';
import {Card, Container} from 'react-bootstrap';
import {Tooltip} from 'react-tooltip';
import {Outlet} from 'react-router';
import Export from '../../../pages/private/Export/Export';
import ProfileModal from '../../../pages/private/Profile/ProfileModal';
import { CenteredSpinner } from '../../util/widgets/CenteredSpinner/CenteredSpinner';
import StandardModal from '../../util/StandardModal/StandardModal';
import AuditLogLoader from '../../../pages/private/AuditLog/AuditLogLoader';

const PrivateBody = (props: {}) => {
  const [exportOpen, setExportOpen] = React.useState(false);
  const [exportLoading, setExportLoading] = React.useState(false);
  const [profileOpen, setProfileOpen] = React.useState(false);
  const [auditOpen, setAuditOpen] = React.useState(false);

  const handleOpenExport = () => {
    setExportLoading(true);
    setExportOpen(true);
  };
  const handleCloseExport = () => {
    setExportOpen(false);
    setExportLoading(false);
  };

  const handleOpenProfile = () => {
    setProfileOpen(true);
  };
  const handleCloseProfile = () => {
    setProfileOpen(false);
  };

  const handleOpenAudit = () => setAuditOpen(true);
  const handleCloseAudit = () => setAuditOpen(false);

  return (
    <Container fluid={true} className={styles['page-body']}>
      <Tooltip id='tooltip-id-anchor' place='top' closeOnEsc={true} delayShow={100} style={{zIndex: 2000}}/>
      <div style={{display: 'flex', height: '100%', maxWidth: '100vw'}}>
        <SidebarPanel onOpenExport={handleOpenExport} onOpenProfile={handleOpenProfile} onOpenAuditLogs={handleOpenAudit}/>
        <main style={{display: 'flex', flexDirection: 'column', flex: '1', overflowY: 'scroll'}}>
          <Container fluid={true} className={styles['config-container']}>
            <Card style={{display: 'flex', flexDirection: 'column', flex: '1', backgroundColor: '#f3f6f8', border: 'none'}}>
              <Card.Body>
                <Outlet/>
              </Card.Body>
            </Card>
          </Container>
        </main>
      </div>
      {/* Export modal using StandardModal */}
      <StandardModal
        opened={exportOpen}
        onCancel={handleCloseExport}
        title={'Export'}
        size={'sm'}
        submitText={'Start export'}
        cancelText={'Close'}
        formId={'export-form'}
      >
        <div style={{ position: 'relative', minHeight: 120 }}>
          {exportLoading && (
            <div style={{
              position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'rgba(255,255,255,0.6)', zIndex: 1
            }}>
              <CenteredSpinner />
            </div>
          )}
          <Export onLoadingChange={setExportLoading} />
        </div>
      </StandardModal>

      {/* Profile modal using StandardModal + Formik (ProfileModal) */}
      <StandardModal
        opened={profileOpen}
        onCancel={handleCloseProfile}
        title={'Profile'}
        size={'lg'}
        cancelText={'Close'}
        submitText={'Save Password'}
        formId={'profile-form'}
      >
        <div style={{ position: 'relative' }}>
          <ProfileModal onClose={handleCloseProfile} formId={'profile-form'} />
        </div>
      </StandardModal>

      {/* Audit Log Viewer */}
      <AuditLogLoader opened={auditOpen} onClose={handleCloseAudit} />
    </Container>
  );
};

export default PrivateBody;
